<ng-container *ngIf="icon">
	<button type="button" mat-icon-button class="icon-cell-button" (click)="onClick()">
		<mat-icon
				[svgIcon]="icon" 
				class="copo-datacenter-grid-icon-16">
		</mat-icon>
	</button>
</ng-container>